import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api, guardarSessao } from '../dados/api.js'
import { InstalarApp } from '../componentes/InstalarApp.js'
import {
  descreverDispositivo,
  iniciarLogin,
  lerErroDeLogin,
  loginConfigurado as configurado,
  traduzirErroDeLogin as traduzir,
} from '../dados/login.js'

/// Login. Acontece uma vez a cada 30 dias, sempre com rede — depois disso o app
/// funciona sozinho. A mecânica do Entra ID (redirecionamento, volta, troca pelo
/// token de dispositivo) mora em dados/login.ts.

export function Entrar() {
  const [carregando, setCarregando] = useState(false)
  // Um erro na volta da Microsoft aconteceu antes desta tela existir; ele chega
  // guardado e é mostrado uma vez.
  const [erro, setErro] = useState<string | null>(() => lerErroDeLogin())
  const navegar = useNavigate()

  async function entrarComMicrosoft() {
    setCarregando(true)
    setErro(null)
    try {
      // Sai da página: a próxima coisa que acontece é a volta da Microsoft,
      // tratada no main.tsx.
      await iniciarLogin()
    } catch (e) {
      setErro(traduzir(e))
      setCarregando(false)
    }
  }

  async function entrarModoDesenvolvimento() {
    setCarregando(true)
    setErro(null)
    try {
      const sessao = await api.entrarDev(descreverDispositivo())
      await guardarSessao(sessao)
      navegar('/', { replace: true })
    } catch (e) {
      setErro(traduzir(e))
    } finally {
      setCarregando(false)
    }
  }

  return (
    <div className="flex min-h-screen flex-col justify-center bg-marinho px-6">
      <div className="mx-auto w-full max-w-sm">
        <div className="mb-8 text-center">
          <span className="mx-auto mb-4 grid h-16 w-16 place-items-center rounded-2xl bg-limao">
            <svg viewBox="0 0 24 24" className="h-9 w-9 text-marinho-900" fill="none" stroke="currentColor" strokeWidth="3">
              <path d="M5 13l4 4 10-11" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <h1 className="text-2xl font-bold text-white">Sistema QSMS</h1>
          <p className="mt-1 text-sm text-marinho-100">
            Inspeções, notificações e interdições
            <br />
            Construtora Ápia
          </p>
        </div>

        {erro && (
          <div className="mb-4 rounded-lg bg-white/95 p-3 text-sm text-alta" role="alert">
            {erro}
          </div>
        )}

        {configurado ? (
          <button onClick={entrarComMicrosoft} disabled={carregando} className="botao-destaque w-full">
            {carregando ? 'Entrando…' : 'Entrar com a conta Ápia'}
          </button>
        ) : (
          <>
            <button onClick={entrarModoDesenvolvimento} disabled={carregando} className="botao-destaque w-full">
              {carregando ? 'Entrando…' : 'Entrar (modo desenvolvimento)'}
            </button>
            <p className="mt-3 text-center text-xs text-marinho-100">
              O login Microsoft ainda não está configurado neste ambiente.
            </p>
          </>
        )}

        <p className="mt-8 text-center text-xs text-marinho-200">
          Depois de entrar, o aplicativo funciona sem internet por 30 dias.
        </p>

        {/* Antes do login é a melhor hora: no iPhone, o app instalado não
            aproveita o login feito no Safari. */}
        <div className="mt-6 text-left">
          <InstalarApp />
        </div>
      </div>
    </div>
  )
}
